import React from 'react'
import { Image } from 'semantic-ui-react'
import styled from 'styled-components';

import { __ } from '~/i18n'
import emptyImage from '~/assets/img/empty-cart.svg'
import Link from '~/components/link'

const EmptyContainer = styled.div`
  text-align: center;
  padding-top: 45px;
  
  img {
    max-width: 160px;
  }
`;

const EmptyTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #1B2125;
  text-align: center;
  line-height: 24px;
  margin: 24px 0 8px;
`;

const EmptyHelp = styled.div`
  font-size: 14px;
  color: #868686;
  text-align: center;
  line-height: 24px;
  max-width: 200px;
  margin: 0 auto 32px;
`;

const BackLink = styled(Link)`
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  font-weight: bold;
`;

export default class EmptyCart extends React.PureComponent {
  render() {
    const { onClose } = this.props;
    return (
      <EmptyContainer>
        <Image src={ emptyImage } centered/>
        <EmptyTitle>{ __('Your cart is empty')}</EmptyTitle>
        <EmptyHelp>{ __('Looks like you haven\'t made your choice yet')}</EmptyHelp>
        <div>
          <BackLink href="#" onClick={(e) => {
            e.preventDefault();
            onClose();
          }}>{ __('Back to browsing')}</BackLink>
        </div>
      </EmptyContainer>
    )
  }
}
